export default __webpack_public_path__ + "static/media/CEDIA-cosecha sostenible.7ea5cc62.jpg";